/* Mikaya — guest-friendly wishlist (localStorage) + optional capture-to-sheet.
   No signup required to save; a soft prompt captures email/WhatsApp so the
   business can follow up (back-in-stock, sale, reminder). */
(function () {
  var STORAGE_KEY = 'mk_wishlist';
  var CAPTURED_KEY = 'mk_wishlist_captured'; // permanent: set only after a successful submit
  var SESSION_SHOWN_KEY = 'mk_wishlist_shown_session'; // per-session: don't nag twice in one visit
  // Google Apps Script web app that appends {contact, wishlist, handles, page} to a Sheet.
  var CAPTURE_ENDPOINT = window.MK_WISHLIST_ENDPOINT || 'https://script.google.com/macros/s/AKfycbxPXrwbdyZzjjndy89zuIAVuEu5vpJs8yEbn8nSo7yRC7ql1ekSg72Sza_-Y51UQiNP6A/exec';

  function getList() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; }
    catch (e) { return []; }
  }
  function saveList(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    updateAllButtons();
    updateBadge();
    document.dispatchEvent(new CustomEvent('mk:wishlist-change', { detail: { list: list } }));
  }
  function isSaved(handle) {
    return getList().some(function (i) { return i.handle === handle; });
  }
  function toggle(data) {
    var list = getList();
    var idx = list.findIndex(function (i) { return i.handle === data.handle; });
    if (idx > -1) { list.splice(idx, 1); }
    else { list.push(data); }
    saveList(list);
    return idx === -1; // true = just added
  }
  function remove(handle) {
    saveList(getList().filter(function (i) { return i.handle !== handle; }));
  }

  function updateAllButtons() {
    var list = getList();
    document.querySelectorAll('[data-mk-wishlist-toggle]').forEach(function (btn) {
      var handle = btn.getAttribute('data-handle');
      var saved = list.some(function (i) { return i.handle === handle; });
      btn.classList.toggle('is-active', saved);
      btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
    });
  }
  function updateBadge() {
    var count = getList().length;
    document.querySelectorAll('[data-mk-wishlist-count]').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-mk-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    var data = {
      handle: btn.getAttribute('data-handle'),
      title: btn.getAttribute('data-title'),
      image: btn.getAttribute('data-image'),
      price: btn.getAttribute('data-price'),
      url: btn.getAttribute('data-url'),
      scent: btn.getAttribute('data-scent') || '',
      compare: btn.getAttribute('data-compare') || '',
      variantId: btn.getAttribute('data-variant-id'),
      variants: btn.getAttribute('data-variants') || '',
      multi: btn.getAttribute('data-multi') === '1',
      available: btn.getAttribute('data-available') !== '0'
    };
    var added = toggle(data);
    btn.classList.add('mk-pulse');
    setTimeout(function () { btn.classList.remove('mk-pulse'); }, 350);
    if (added) maybeShowCapture();
  });

  // ---- capture prompt ----
  // Shows on the first save of a session, unless the visitor already gave
  // contact info (permanent, via CAPTURED_KEY) or already saw/dismissed it
  // this same session (SESSION_SHOWN_KEY, cleared when the tab/browser closes).
  // Dismissing without submitting only silences it for the rest of THIS visit —
  // it reappears next time they open a new session and save something.
  function maybeShowCapture() {
    if (localStorage.getItem(CAPTURED_KEY)) return;
    if (sessionStorage.getItem(SESSION_SHOWN_KEY)) return;
    var el = document.getElementById('mk-wishlist-capture');
    if (el) el.classList.add('is-visible');
    sessionStorage.setItem(SESSION_SHOWN_KEY, '1');
  }
  function dismissCapture(captured) {
    var el = document.getElementById('mk-wishlist-capture');
    if (el) el.classList.remove('is-visible');
    if (captured) localStorage.setItem(CAPTURED_KEY, '1'); // only set on a real submit
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('#mk-wishlist-capture-form');
    if (!form) return;
    e.preventDefault();
    var input = form.querySelector('input[name="contact"]');
    var contact = input ? input.value.trim() : '';
    if (!contact) return;
    var statusEl = form.querySelector('.mk-wishlist-capture__status');
    var payload = {
      contact: contact,
      wishlist: getList().map(function (i) { return i.title; }).join(', '),
      handles: getList().map(function (i) { return i.handle; }).join(', '),
      page: window.location.href,
      submitted_at: new Date().toISOString()
    };
    if (!CAPTURE_ENDPOINT) {
      if (statusEl) statusEl.textContent = 'Saved on this device.';
      dismissCapture(true);
      return;
    }
    if (statusEl) statusEl.textContent = 'Saving…';
    fetch(CAPTURE_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain' }, // avoids CORS preflight to Apps Script
      body: JSON.stringify(payload)
    }).then(function () {
      if (statusEl) statusEl.textContent = "You're on the list — we'll let you know.";
      dismissCapture(true);
    }).catch(function () {
      if (statusEl) statusEl.textContent = 'Saved on this device.';
      dismissCapture(true);
    });
  });

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-mk-wishlist-dismiss]')) dismissCapture(false);
  });

  // ---- wishlist page rendering ----
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  // add-to-cart block, byte-for-byte matching mk-atc.liquid so the wishlist
  // card behaves exactly like the site's product cards (single → AJAX add,
  // multi → same variant popup via mk-variant.js, sold out → disabled).
  function atcBlock(item) {
    if (item.available === false) {
      return '<span class="mk-atc mk-atc--soldout" aria-disabled="true"><span class="mk-atc__label">Sold out</span></span>';
    }
    if (item.multi) {
      var vdata = {
        title: item.title, url: item.url, image: item.image,
        variants: (function () { try { return JSON.parse(item.variants || '[]'); } catch (e) { return []; } })()
      };
      var json = JSON.stringify(vdata).replace(/</g, '\\u003c');
      return '<button type="button" class="mk-atc" data-mk-variant aria-haspopup="dialog" aria-label="Choose options for ' + esc(item.title) + '">' +
        '<span class="mk-atc__label">Add to cart</span></button>' +
        '<script type="application/json" class="mk-variant-data">' + json + '</script>';
    }
    return '<button type="button" class="mk-atc" data-mk-atc data-variant-id="' + esc(item.variantId) + '" aria-label="Add ' + esc(item.title) + ' to cart">' +
      '<span class="mk-atc__label">Add to cart</span>' +
      '<span class="mk-atc__added">Added&nbsp;✓</span></button>';
  }

  function priceBlock(item) {
    if (item.compare) {
      return '<span class="mk-card__price--sale">' + esc(item.price) + '</span>' +
        '<s class="mk-card__price--was">' + esc(item.compare) + '</s>';
    }
    return esc(item.price);
  }

  function renderWishlistPage() {
    var grid = document.getElementById('mk-wishlist-grid');
    if (!grid) return;
    var empty = document.getElementById('mk-wishlist-empty');
    var toolbar = document.getElementById('mk-wishlist-toolbar');
    var countEl = document.getElementById('mk-wishlist-page-count');
    var list = getList();

    if (countEl) countEl.textContent = list.length ? (list.length + (list.length === 1 ? ' item' : ' items')) : '';
    if (toolbar) toolbar.style.display = list.length ? '' : 'none';

    if (!list.length) {
      grid.innerHTML = '';
      if (empty) empty.style.display = '';
      return;
    }
    if (empty) empty.style.display = 'none';
    // identical structure to snippets/mk-product-card.liquid so it renders
    // pixel-for-pixel like every other card on the site
    grid.innerHTML = list.map(function (item) {
      return (
        '<div class="mk-card-wrap mk-wl-item">' +
          '<div class="mk-card__media">' +
            '<button type="button" class="mk-wl-card__remove" data-mk-wishlist-remove="' + esc(item.handle) + '" aria-label="Remove ' + esc(item.title) + '">&times;</button>' +
            '<a href="' + esc(item.url) + '" class="mk-card__media-link" tabindex="-1" aria-hidden="true">' +
              '<img src="' + esc(item.image) + '" alt="' + esc(item.title) + '" class="mk-card__img" loading="lazy">' +
            '</a>' +
          '</div>' +
          (item.scent ? '<p class="mk-card__scent">' + esc(item.scent) + '</p>' : '') +
          '<div class="mk-card__body">' +
            '<a href="' + esc(item.url) + '" class="mk-card__link"><h3 class="mk-card__title">' + esc(item.title) + '</h3></a>' +
            '<div class="mk-card__footer">' +
              '<span class="mk-card__price">' + priceBlock(item) + '</span>' +
              '<div class="mk-card__atc">' + atcBlock(item) + '</div>' +
            '</div>' +
          '</div>' +
        '</div>'
      );
    }).join('');
  }

  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-mk-wishlist-remove]');
    if (!rm) return;
    remove(rm.getAttribute('data-mk-wishlist-remove'));
    renderWishlistPage();
  });

  // "Add all to bag" — adds every in-stock, single-variant item, then refreshes
  document.addEventListener('click', function (e) {
    if (!e.target.closest('#mk-wishlist-addall')) return;
    var addable = getList().filter(function (i) { return i.available !== false && !i.multi && i.variantId; });
    if (!addable.length) return;
    var items = addable.map(function (i) { return { id: i.variantId, quantity: 1 }; });
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function () {
      window.location.href = '/cart';
    });
  });
  document.addEventListener('mk:wishlist-change', renderWishlistPage);

  document.addEventListener('DOMContentLoaded', function () {
    updateAllButtons();
    updateBadge();
    renderWishlistPage();
  });
})();
